import React, { useEffect, useState } from 'react'
import { Space, Table, Modal, Flex } from 'antd';
import { useShangpinguigeListQuery } from '../../store/dianshangtaizhangApi';
import GoodsSpecEdit from './GoodsSpecEdit';
import GoodsSpecAdd from './GoodsSpecAdd';
import GoodsSpecDel from './GoodsSpecDel';
function GoodsSpecQuery(props) {
    const [open, setOpen] = useState(false);
    const [list, setList] = useState();    
    const {data, isSuccess} = useShangpinguigeListQuery({spgg_sp_id:props.sp_id}, {refetchOnMountOrArgChange: true})
    useEffect(() => {
        if (isSuccess) {
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {spgg_id:key,spgg_day,spgg_price,spgg_name,spgg_content,spgg_sp_name,spgg_bianhao,spgg_report_template,spgg_approve_rule} = item;                 
                    return item = {key,spgg_day,spgg_price,spgg_name,spgg_content,spgg_sp_name,spgg_bianhao,spgg_report_template,spgg_approve_rule}
                }) 
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.spgg_ctime;
                    let bTimeString = b.spgg_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
        }
    }, [data, isSuccess])
    const columns = [
        {
            key: 'spgg_bianhao',
            title: '序号',            
            dataIndex: 'spgg_bianhao',
        },
        {
            key: 'spgg_name',
            title: '规格名称',            
            dataIndex: 'spgg_name',
        },
        
        {
            key: 'spgg_price',
            title: '价格',            
            dataIndex: 'spgg_price',
        },
        {
            key: 'spgg_day',
            title: '天数',            
            dataIndex: 'spgg_day',
        },                                 
        {
            key: 'spgg_content',
            title: '备注',            
            dataIndex: 'spgg_content',
        },
        {
            key: 'key',
            title: '编号',            
            dataIndex: 'key',
        },    
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <GoodsSpecEdit spgg_id={record.key} spgg_name={record.spgg_name}/>
                        <GoodsSpecDel spgg_id={record.key}/>
                    </Space>
                </>
            }
        },
    ]   
    return (
        <>            
            <a onClick={() => {setOpen(true)}}>规格</a>
            <Modal
                open={open}
                title={`规格(${props.sp_name})`}
                okText="提交"
                cancelText="取消"
                onCancel={() => {setOpen(false);}}
                onOk={() => {}}
                width={1200}
            >
                <Flex justify='flex-end'>
                    <GoodsSpecAdd sp_id={props.sp_id} sp_name={props.sp_name}/>
                </Flex>
                <Table 
                    columns={columns} 
                    dataSource={list} 
                    pagination={{
                        showSizeChanger:true,
                        defaultPageSize:'50',
                        showTotal:(total) => `共${total}条`,
                    }} 
                />
            </Modal>
        </>
    )
}

export default GoodsSpecQuery